<h2 i18n="@@mergeCustomer.heading.assembleCustomer">Assemble customer</h2>
<p i18n="@@mergeCustomer.subheading.assembleCustomer">
  On the left and right column we have our two customers we want to merge to the middle column. With the buttons below you can select
  which customer's data will you primarily take. You can also drag and drop any set of data by dragging it to the merged preview.
</p>

<div class="esf-info-tile-grid esf-info-tile-grid--3">
  <div class="esf-button">
    <button class="esf-button esf-button--small esf-button--filled"
            i18n="@@mergeCustomer.button.copyFirstCustomer"
            (click)="clearAndSet(firstCustomerData[0])">
      Copy first customer data to merged preview
    </button>
  </div>

  <div class="esf-button">
  </div>

  <div class="esf-button">
    <button class="esf-button esf-button--small esf-button--filled"
            i18n="@@mergeCustomer.button.copySecondCustomer"
            (click)="clearAndSet(secondCustomerData[0])">
      Copy second customer data to merged preview
    </button>
  </div>
</div>
<div class="esf-info-tile-grid esf-info-tile-grid--3">
  <div class="esf-info-tile-grid">

    <h3 i18n="@@mergeCustomer.heading.firstCustomer">First customer</h3>

    <app-merge-customer-data [id]="'firstCustomerData'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nCustomerData"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>

  </div>

  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">

    <h3 i18n="@@mergeCustomer.heading.mergedPreview">Merged preview</h3>

    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nCustomerData"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>

  </div>

  <div class="esf-info-tile-grid">

    <h3 i18n="@@mergeCustomer.heading.secondCustomer">Second customer</h3>

    <app-merge-customer-data [id]="'secondCustomerData'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nCustomerData"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>

  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerCommunication'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nComunicationData"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">
    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nComunicationData"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerCommunication'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nComunicationData"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerAttributes'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nAttribute"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">
    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nAttribute"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerAttributes'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nAttribute"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" *ngIf="selectedClub.isCrmMembershipActive">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerMembership'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nMembership"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">
    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nMembership"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerMembership'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nMembership"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" *ngIf="selectedClub.isCampaiMembershipActive">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerMembership'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nMembershipCampai"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">
    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nMembershipCampai"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerMembership'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nMembershipCampai"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerStandardAddress'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nStandardAddress"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">
    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nStandardAddress"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerStandardAddress'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nStandardAddress"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerAddresses'"
                             [customer]="firstCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nAddresses"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
  <div class="esf-info-tile-grid" style="background-color: rgb(228, 237, 247);">
    <app-merge-customer-final [triggered]="triggered"
                              [type]="tablesTranslations.i18nAddresses"
                              [customer]="combinedCustomer"
                              [countries]="countries"
                              (combinedCustomerUpdated)="setCombinedCustomer($event)">
    </app-merge-customer-final>
  </div>
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerAddresses'"
                             [customer]="secondCustomerData"
                             [combinedCustomer]="combinedCustomer"
                             [type]="tablesTranslations.i18nAddresses"
                             [countries]="countries"
                             [selectedClub]="selectedClub">
    </app-merge-customer-data>
  </div>
</div>
